import { useTranslation } from '@framework/i18n';
import { FlexRow } from '@framework/ui';
import { Divider, Flex, Space, Typography } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

const { Text, Title } = Typography;

const SecondaryText = styled(Text)`
  font-weight: normal;
  opacity: 0.8;
  line-height: 1;
`;

export interface ICommunicationActorsContainerProps {
  from?: React.ReactNode;
  to?: React.ReactNode;
  showDivider?: boolean;
}

/**
 * Singola comunicazione
 */
export function CommunicationActorsContainer(
  props: ICommunicationActorsContainerProps,
) {
  const { from, to, showDivider = true } = props;
  const { t } = useTranslation();

  return (
    <Flex vertical>
      <Space size={[8, 0]} wrap>
        <SecondaryText>
          {t('communication-details.sender', 'Mittente')}:
        </SecondaryText>
        {from}
      </Space>
      <FlexRow
        align="flex-start"
        gutter={8}
        left={
          <SecondaryText>
            {t('communication-details.receiver', 'Destinatari')}:
          </SecondaryText>
        }
      >
        <Flex gap={8} vertical>
          {to}
        </Flex>
      </FlexRow>
      {/* <Space size={[8, 0]} wrap>
        <SecondaryText>
          {t('communication-details.receiver', 'Destinatari')}:
        </SecondaryText>
        {to}
      </Space> */}
      {showDivider && <Divider style={{ marginTop: 8, marginBottom: 8 }} />}
    </Flex>
  );
}
